// Copyright (c) 2017 Deere & Company

import {combineReducers} from 'redux';
import data from './data';

export const getCombinedReducers = () => combineReducers({
    data
});




// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/reducers/index.js